module.exports = __webpack_public_path__ + "static/media/att-profile.651bb765.svg";